import * as yup from 'yup';
import { isPhoneNumber } from 'class-validator';

export const testingSchema = yup.object({
  userInfo: yup.object({
    firstName: yup.string().required('Введіть ваше Ім\'я'),
    email: yup.string().email('Введіть email коректно').required('Введіть ваш email'),
    phoneNumber: yup.string()
      .required('Введіть ваш номер телефону')
      .test(
        'is-phone-number-valid',
        'Введіть номер телефону коректно',
        (value) => isPhoneNumber(value ? value : '', 'UA')
      ),
  }),
  answers: yup.array()
    .of(
      yup.object({
        questionText: yup.string(),
        answer: yup.boolean(),
      }),
    )
});
